<template>
  <div class="emd-pulse" :class="`_color_${color}`">
    <div class="emd-pulse__item _first"></div>
    <div class="emd-pulse__item"></div>
    <div class="emd-pulse__item _pulse"></div>
    <div class="emd-pulse__item _last"></div>
  </div>
</template>

<script>
export default {
  name: 'EmdPulse',
  props: {
    color: {
      type: String,
      default: 'primary',
      required: false,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary'].indexOf(value) !== -1
      }
    }
  }
}
</script>
